"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberWithTypeTypeEnum = exports.PhoneNumberWithTypeToJSON = exports.PhoneNumberWithTypeFromJSONTyped = exports.PhoneNumberWithTypeFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PhoneNumberWithTypeFromJSON(json) {
    return PhoneNumberWithTypeFromJSONTyped(json, false);
}
exports.PhoneNumberWithTypeFromJSON = PhoneNumberWithTypeFromJSON;
function PhoneNumberWithTypeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'index': json['index'],
        'number': json['number'],
        'when': !(0, runtime_1.exists)(json, 'when') ? undefined : (0, _1.PhoneTimeFromJSON)(json['when']),
        'parcelShopSMS': !(0, runtime_1.exists)(json, 'parcelShopSMS') ? undefined : json['parcelShopSMS'],
    };
}
exports.PhoneNumberWithTypeFromJSONTyped = PhoneNumberWithTypeFromJSONTyped;
function PhoneNumberWithTypeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'index': value.index,
        'number': value.number,
        'when': (0, _1.PhoneTimeToJSON)(value.when),
        'parcelShopSMS': value.parcelShopSMS,
    };
}
exports.PhoneNumberWithTypeToJSON = PhoneNumberWithTypeToJSON;
/**
* @export
* @enum {string}
*/
var PhoneNumberWithTypeTypeEnum;
(function (PhoneNumberWithTypeTypeEnum) {
    PhoneNumberWithTypeTypeEnum["MOBILE"] = "MOBILE";
    PhoneNumberWithTypeTypeEnum["FIXED"] = "FIXED";
})(PhoneNumberWithTypeTypeEnum = exports.PhoneNumberWithTypeTypeEnum || (exports.PhoneNumberWithTypeTypeEnum = {}));
//# sourceMappingURL=PhoneNumberWithType.js.map